import React from "react";
import { SxProps, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import theme from "../../components/styles/theme/theme";
import { GridRowClassNameParams } from "@mui/x-data-grid";
import { LATAMCountries } from "./types";
import {
  LATAM_COUNTRY_NAMES,
  ROMANIA_REGION,
} from "../../features/countries/types";
import { styled } from "@mui/material/styles";
import { REGIONS_NAME } from "../../config";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export const getRowClassName = (params: GridRowClassNameParams) => {
  let classNames = "";

  if (!params.row.isActive) {
    classNames += "inactive-row ";
  }

  if (params.row.isAdmin) {
    classNames += "admin-row ";
  }

  return classNames.trim();
};

export const dataGridStyle: SxProps = {
  "& .admin-row": {
    borderLeft: `4px solid ${theme.palette.secondary.main}`,
  },
  "& .inactive-row": {
    borderLeft: `4px solid ${theme.palette.common.black}`,
  },
};

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const getBorderStyle = (option: string) => {
  return {
    backgroundColor: `${theme.palette.common.white}`,
    border:
      option.includes("latam") ||
      LATAMCountries.includes(option as LATAM_COUNTRY_NAMES)
        ? `1px solid ${theme.palette.secondary.main}`
        : option.includes("romania") ||
          option.includes(ROMANIA_REGION.ROMANIA) ||
          option.includes(REGIONS_NAME.ROMANIA)
        ? `1px solid ${theme.palette.custom.purple}`
        : `1px solid transparent`,
    color:
      option.includes("latam") ||
      LATAMCountries.includes(option as LATAM_COUNTRY_NAMES)
        ? `${theme.palette.secondary.main}`
        : option.includes("romania") || option.includes(ROMANIA_REGION.ROMANIA)
        ? `${theme.palette.custom.purple}`
        : `inherit`,
  };
};

export const getStylesForMenuItem = (
  option: string,
  options: readonly string[]
) => {
  return {
    fontWeight:
      options.indexOf(option) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    backgroundColor:
      options.indexOf(option) === -1
        ? theme.palette.component.light
        : theme.palette.component[300],

    borderLeft:
      option.includes("latam") ||
      LATAMCountries.includes(option as LATAM_COUNTRY_NAMES)
        ? `3px solid ${theme.palette.secondary.main}`
        : option.includes("romania") || option.includes(ROMANIA_REGION.ROMANIA)
        ? `3px solid ${theme.palette.custom.purple}`
        : "3px solid transparent",
  };
};

export const StyledTooltip = styled(
  ({ className, children, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} children={children} />
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}));
